import { render } from "./CohortTemplateCard.vue?vue&type=template&id=afb2aca4"
import script from "./CohortTemplateCard.vue?vue&type=script&lang=js"
export * from "./CohortTemplateCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__